
import React, { useState } from "react";
import SlideNavigation from "./components/SlideNavigation";
import IntroSlide from "./slides/IntroSlide";
import ProductLineupSlide from "./slides/ProductLineupSlide";
import ProductsDetailSlide from "./slides/ProductsDetailSlide";
import CustomerTrendsSlide from "./slides/CustomerTrendsSlide";
import ResultsSlide from "./slides/ResultsSlide";
import ContactSlide from "./slides/ContactSlide";
import { SlideType } from "./types";
import ordersalesLogo from "@/assets/ordersales-logo.png";

const PitchDeck = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const slides: SlideType[] = [
    {
      id: "intro",
      title: "Määrittelemme verkkokaupan tulevaisuuden",
      component: <IntroSlide />,
    },
    {
      id: "product-lineup",
      title: "Tuotevalikoimamme",
      component: <ProductLineupSlide />,
    },
    {
      id: "products-detail",
      title: "Tuotteiden yksityiskohdat",
      component: <ProductsDetailSlide />,
    },
    {
      id: "customer-trends",
      title: "Asiakaskäyttäytyminen ja trendit",
      component: <CustomerTrendsSlide />,
    },
    {
      id: "results",
      title: "Uudelleenmäärittelemme verkkokaupan",
      component: <ResultsSlide />,
    },
    {
      id: "contact",
      title: "Ota yhteyttä",
      component: <ContactSlide />,
    },
  ];

  const nextSlide = () => {
    setCurrentSlideIndex((prevIndex) =>
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlideIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const currentSlide = slides[currentSlideIndex];

  return (
    <div className="flex min-h-screen flex-col bg-white text-indigo-900">
      <main className="flex-1 relative">
        <div className="absolute inset-0 -z-10">
          <div className="absolute inset-0 bg-white"></div>
          <div className="absolute top-0 left-0 right-0 h-1/3 bg-gradient-to-b from-violet-50/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-indigo-50/20 to-transparent"></div>
        </div>

        <section className="py-20">
          <div className="container mx-auto px-4 max-w-6xl">
            <div className="text-center mb-8">
              <img src={ordersalesLogo} alt="OrderSales.AI" className="h-12 mx-auto mb-4" />
              <p className="text-indigo-700 font-cursive">Pitch Deck</p>
            </div>
            
            <SlideNavigation 
              currentSlideIndex={currentSlideIndex}
              totalSlides={slides.length}
              slideTitle={currentSlide.title}
              onPrevSlide={prevSlide}
              onNextSlide={nextSlide}
              onSlideSelect={setCurrentSlideIndex}
            />

            {currentSlide.component}
          </div>
        </section>
      </main>
    </div>
  );
};

export default PitchDeck;
